import React from 'react';
import { trackEvent } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  isCheckout?: boolean;
  price?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  className = '',
  isCheckout = false,
  price
}: CTAButtonProps) {
  const baseStyles = 'w-full md:w-auto inline-flex flex-col items-center justify-center px-8 py-4 text-xl font-bold rounded-lg shadow-lg transition-all transform hover:scale-105 active:scale-95 text-center';
  const variants = {
    primary: 'bg-green-600 hover:bg-green-500 text-white border-b-4 border-green-800',
    secondary: 'bg-yellow-500 hover:bg-yellow-400 text-gray-900 border-b-4 border-yellow-700'
  };
  const handleClick = (e: React.MouseEvent) => {
    if (isCheckout) {
      trackEvent('InitiateCheckout');
      window.location.href = 'https://pay.hotmart.com/V104120573X?checkoutMode=10';
    } else {
      e.preventDefault();
      const element = document.getElementById('compra');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-5">
      {price && <span className="text-sm font-normal opacity-90 mb-1" data-id="element-6">
          Por solo {price}
        </span>}
      <span data-id="element-7">{children}</span>
    </button>;
}